var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 4H17C17.5523 4 18 4.44772 18 5V15L7 15C6.64936 15 6.31278 15.0602 6 15.1707V5C6 4.44772 6.44771 4 7 4L11 4L11 10.5198C11 10.7221 11.2277 10.8406 11.3934 10.7246L13.5 9.25L15.6066 10.7246C15.7723 10.8406 16 10.7221 16 10.5198V4ZM4 19V18V5C4 3.34315 5.34315 2 7 2H17C18.6569 2 20 3.34315 20 5V16V19C20 20.6569 18.6569 22 17 22H7C5.34315 22 4 20.6569 4 19ZM18 17V18H8.5C8.22386 18 8 18.2239 8 18.5C8 18.7761 8.22386 19 8.5 19H18C18 19.5523 17.5523 20 17 20H7C6.44772 20 6 19.5523 6 19V17.9993C6.00038 17.4473 6.44795 17 7 17L18 17Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/Book.5feb666d783dcf23e0fc650f3df09d67.svg";
export { ForwardRef as ReactComponent };